import { gql } from 'graphql-request'

export const REVERT_BOOK_CHAPTER = gql`
  mutation RevertBookChapter($revertBookChapterId: Int!) {
    revertBookChapter(id: $revertBookChapterId) {
      id
    }
  }
`
